import * as types from "../actionTypes";
import initialState from "reducers/initialState";
import * as eventTypes from "../eventTypes";

const addressesReducer = (state = initialState.currentOffer.clientAddressesData, action) => {
  switch (action.type) {
    case types.LOAD_CLIENT_ADDRESSES_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };
      return result;
    }

    case types.LOAD_CLIENT_ADDRESSES_SUCCEEDED: {
      const { key, addresses } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: addresses.map(item => { return item.partnerAddressId }) };
      return result;
    }

    case types.LOAD_CLIENT_ADDRESSES_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false };
      return result;
    }

    case eventTypes.OFFER_PARTNER_ADDRESSES_UPDATED: {
      const { partnerId } = action.event.eventBody;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: false, loaded: false , refreshAddresses: true };
      return result;
    }

    case eventTypes.OFFER_PARTNER_ADDRESSES_INVALIDATED: {
      const { partnerId } = action.event.eventBody;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: false, loaded: false };
      return result;
    }
 
    case types.REFRESH_PARTNER_ADDRESSES_FINISHED: {
      const { partnerId } = action;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId],   refreshAddresses: false , refreshInProgress: false};
      return result;
    }


    default:
      return state;
  }
};

export default addressesReducer;
